import { useUI } from "providers/UIProvider"

import { Box, Flex } from "@chakra-ui/react"

import ReservationDetailsCar from "./ReservationDetailsCar"
import ReservationDetailsDate from "./ReservationDetailsDate"
import ReservationDetailsService from "./ReservationDetailsService"
import ReservationDetailsStatus from "./ReservationDetailsStatus"
import ReservationDetailsPrices from "./ReservationDetailsPrices"
import ReservationDetailsCompany from "./ReservationDetailsCompany"

import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import Modal from "components/UI/organisms/Modal"
import EditReservationDetailsModal from "../EditReservationDetailsModal"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import ReservationDetailsDiscount from "./ReservationDetailsDiscount"
import ReservationDetailsTotalPrice from "./ReservationDetailsTotalPrice"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"
import { useRef } from "react"
import { useReactToPrint } from "react-to-print"
import PrintDetails from "components/templates/ReservationsTemplate/PrintDetails"

const ReservationDetailsModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { currentReservation: reservation, handleMarkReservationAsPrinted, handleSetVehicleKeyStatus, isReservationDataFetching } = useReservationsContext()
  const { userRole } = useAppContext()
  const editBtnDisabled = isReservationDataFetching || reservation?.statusId === 5 || reservation?.statusId === 6 ||
    (reservation?.statusId === 4 &&
      !(userRole && [IRoles.QAPP_ADMIN, IRoles.WASHER_ADMIN].includes(userRole)));


  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  return (
    <Modal
      isOpen={modals.reservationDetailsModal.isOpened}
      onClose={() => toggleModal("reservationDetailsModal", false)}
      title={T("booking.details.modal.title")}
      styles={{
        headerPadding: "15px 15px 14px 23px",
        width: "566px",
        bodyPadding: "0px 0px 0px 0px",
        height: "95%"
      }}
      closeButtonIcon="red-close"
      closeIconStyles={{ width: "33px", height: "33px", fill: "#7D90A8" }}
      closeOnOverlayClick={false}
    >
      <Box paddingBottom={"20px"} >
        <Flex>
          <ReservationDetailsCar />
          <ReservationDetailsDate />
        </Flex>
        <Flex>
          <ReservationDetailsService />
          <Box style={{ display: "none" }}><PrintDetails ref={componentRef} /></Box>
          <ReservationDetailsStatus />
        </Flex>
        <ReservationDetailsPrices />
        {reservation?.webReservation && <>
          <ReservationDetailsDiscount
            discount={reservation?.discount}
            discountPercent={reservation?.discountPercent}
            discountType={reservation?.discountType}
          />
          <ReservationDetailsTotalPrice totalPrice={reservation?.toTalPrice} />
        </>}
        <ReservationDetailsCompany />
        <Flex>
          <Flex
            background="#E9F2FD"
            height={"60px"}
            width={"100%"}
            margin={"0px 24px"}
            borderRadius={"m"}
            alignItems={"center"}
            justifyContent={"center"}
            position={"relative"}
            padding={"0 24px"}
          >
            <Flex paddingRight="55px">
              <Flex
                borderRadius={"m"}
                width={"160px"}
                height={"38px"}
                backgroundColor={"white"}
                alignItems="center"
                fontSize="12px"
                fontWeight={500}
                paddingLeft="12px"
              >
                {reservation?.customerMobile || ""}
              </Flex>
              <Box position={"absolute"} top={"11px"} left={"255px"}>
                <Button
                  onClick={() => {
                    const phoneNumber = reservation?.customerMobile;
                    if (phoneNumber) {
                      const phoneLink = `tel:${phoneNumber}`;
                      window.location.href = phoneLink;
                    }
                  }}
                  variant="success"
                  text={T("booking.details.modal.call")}
                  smallSpacing
                  leftIcon={
                    <Icon
                      name="call"
                      iconStyles={{
                        width: "15px",
                        height: "15px",
                        fill: "white",
                      }}
                    />
                  }
                  styles={{
                    width: "110px",
                    height: "38px",
                    fontSize: "12px",
                    borderRadius: "m",
                  }}
                />
              </Box>
            </Flex>
          </Flex>
        </Flex>
        <Flex

          width={"100%"}
          alignItems="center"
          justifyContent={"center"}
          mt={"30px"}
        >
          {userRole === IRoles.CASHIER ?
            <Flex style={{ width: "100%", justifyContent: "center", gap: "30px" }}>
              <Button
                text={T("booking.details.modal.print")}
                onClick={() => {
                  handlePrint()
                  handleMarkReservationAsPrinted(reservation?.id ? reservation?.id : 0)
                }}
                leftIcon={
                  <Flex
                    borderRadius={"50%"}
                    height={"34px"}
                    width={"34px"}
                    background={"white"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Icon
                      name="print"
                      iconStyles={{
                        width: "20px",
                        height: "18px",
                        fill: "primary",
                      }}
                    />
                  </Flex>
                }
                style={{ backgroundColor: "#08BA36", width: "180px", height: "63px", fontSize: "xl" }}
                // isDisabled={editBtnDisabled}
                _hover={{ backgroundColor: "#08BA36" }}
              />
              <Button
                text={T("booking.detail.modal.key")}
                onClick={() => {
                  handleSetVehicleKeyStatus(reservation?.id ?? 0)
                }}
                leftIcon={
                  <Flex
                    borderRadius={"50%"}
                    height={"34px"}
                    width={"34px"}
                    background={"white"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Icon
                      name="search"
                      iconStyles={{
                        width: "20px",
                        height: "18px",
                        fill: "#f1c40f",
                      }}
                    />
                  </Flex>
                }
                style={{ backgroundColor: "#f1c40f", width: "180px", height: "63px", fontSize: "xl" }}
                // isDisabled={editBtnDisabled}
                _hover={{ backgroundColor: "#f1c40f" }}
              /> </Flex> : <Button
              text={T("booking.details.modal.correction")}
              onClick={() => toggleModal("editReservationDetailsModal", true)}
              leftIcon={
                <Flex
                  borderRadius={"50%"}
                  height={"34px"}
                  width={"34px"}
                  background={"white"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Icon
                    name="edit"
                    iconStyles={{
                      width: "16px",
                      height: "12px",
                      fill: "primary",
                    }}
                  />
                </Flex>
              }
              styles={{ width: "180px", height: "63px", fontSize: "xl" }}
              isDisabled={editBtnDisabled}
            />
          }


        </Flex>
        {modals.editReservationDetailsModal.isOpened && <EditReservationDetailsModal />}
      </Box>
    </Modal>
  )
}

export default ReservationDetailsModal
